import axios from "@src/network"
import { PaginationPayload, usePlainSWRNoMount } from "@hooks/usePlainSWR"
import { ADMIN_RAFFLE_SORT, RAFFLES_ORDER, RafflesPayload } from "@modules/raffles/dto"
import { useEffect, useState } from "react"

export type UserRafflesEntry = {
  createdAt: Date
  entryNumber: number
  id: number
  isWinner: boolean
  raffle: {
    prizeInDollars: number
    winnersCount: number
    entryCost: number
    deadline: Date
    id: number
  }
  raffleId: number
  updatedAt: Date
  userId: string
}

const fetchCurrentUserRafflesEntry = async (userId: string, payload: RafflesPayload & PaginationPayload) => {
  const { sortOrder, search, perPage, page, sortBy } = payload

  const params: any = {
    sortBy,
    sortOrder,
    take: perPage,
    skip: perPage * (page - 1),
    search
  }

  const res = await axios.get(`/users/${userId}/raffle-entries`, {
    params,
    withCredentials: true
  })

  return { data: { items: res.data.items, total: res.data.totalCount } }
}

export const useCurrentUserRafflesEntry = (userId: string) => {
  const [filter, setFilter] = useState<RafflesPayload>({
    sortBy: ADMIN_RAFFLE_SORT.DATE,
    sortOrder: RAFFLES_ORDER.DESC
  })
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(6)

  const {
    data,
    mutate: refresh,
    error
  } = usePlainSWRNoMount(`users/${userId}/raffle-entries`, () => fetchCurrentUserRafflesEntry(userId, {
    ...filter,
    page,
    perPage
  }))

  useEffect(() => {
    refresh()
  }, [page, perPage, filter])

  const loading = !data && !error
  const rafflesEntry: UserRafflesEntry[] = data?.items || []
  return {
    loading,
    rafflesEntry,
    refresh,
    error,

    page,
    onChangePage: setPage,

    perPage,
    onChangePerPage: setPerPage,

    total: data?.total || 0,

    onFiltered: (newFilter: Partial<RafflesPayload>) => setFilter((prev) => ({ ...prev, ...newFilter })),
    filter
  }
}